import { StringParam, withDefault } from 'use-query-params';

function createSearchQueryParam<T>(defaultValue: T | undefined) {
  return withDefault(StringParam, defaultValue);
}

export default createSearchQueryParam;
